(() => {
  const existingBootstrap = window.ChefollaCustomerReviews;

  if (existingBootstrap) {
    existingBootstrap.initAll(document);
    return;
  }

  class CustomerReviews {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-customer-reviews-track]');
      this.controls = root.querySelector('[data-customer-reviews-controls]');
      this.previousButton = root.querySelector('[data-customer-reviews-previous]');
      this.nextButton = root.querySelector('[data-customer-reviews-next]');
      this.cards = this.track ? Array.from(this.track.querySelectorAll('[data-customer-reviews-card]')) : [];
      this.resizeFrame = null;

      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handlePrevious = () => this.scrollByCard(-1);
      this.handleNext = () => this.scrollByCard(1);
      this.handleScroll = () => this.updateControls();
      this.handleResize = () => {
        window.cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = window.requestAnimationFrame(() => this.updateControls());
      };

      this.init();
    }

    init() {
      if (!this.track) return;

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.updateControls();
      window.requestAnimationFrame(() => this.updateControls());
    }

    getCardStep() {
      const firstCard = this.cards[0];
      if (!firstCard) return 0;

      const trackStyles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    scrollByCard(direction) {
      const step = this.getCardStep();
      if (step === 0) return;

      this.track.scrollBy({
        left: step * direction,
        behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth',
      });
    }

    updateControls() {
      if (!this.controls || !this.previousButton || !this.nextButton) return;

      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const hasOverflow = maxScroll > 1;
      this.controls.classList.toggle('is-hidden', !hasOverflow);
      this.root.classList.toggle('has-no-overflow', !hasOverflow);
      this.previousButton.disabled = !hasOverflow || this.track.scrollLeft <= 1;
      this.nextButton.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 1;
    }

    destroy() {
      window.cancelAnimationFrame(this.resizeFrame);
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      delete this.root.customerReviewsInstance;
    }
  }

  function collectRoots(container) {
    const roots = [];
    if (container.matches?.('[data-customer-reviews]')) roots.push(container);
    roots.push(...(container.querySelectorAll?.('[data-customer-reviews]') || []));
    return roots;
  }

  function initAll(container) {
    collectRoots(container).forEach((root) => {
      if (!root.customerReviewsInstance) root.customerReviewsInstance = new CustomerReviews(root);
    });
  }

  function destroyAll(container) {
    collectRoots(container).forEach((root) => root.customerReviewsInstance?.destroy());
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyAll(event.target));

  window.ChefollaCustomerReviews = { initAll, destroyAll };
  initAll(document);
})();
